/*eslint-disable */
import React from 'react';
import styles from '../styles/index.less';

const BizTabList = ({ tabList, handleTabClick, type = '' }) => {
  return (
    <ul className={`${styles['tabs']} ${styles[type]}`} id="apply-direct-tabs">
      {tabList?.map(item => {
        const { new_change, biz_id, biz_name } = item;
        return (
          <span
            className={`${styles['tabs-item']} ${new_change ? styles['dot'] : ''}`}
            key={biz_id}
            onClick={() => handleTabClick(item, type)}
          >
            {biz_name}
          </span>
        );
      })}
    </ul>
  );
};
export default BizTabList;
